import React from 'react'
import Icon from '../Icon'
import './search.sass'

const Search = () => (
  <div className="search-wrapper input-wrapper">
    <input type="search" placeholder="Введите название услуги" />
    <button className="send-button">
      <div className="send-button__wrapper-img">
        <Icon type='search' />
      </div>
    </button>
  </div>
)

export default Search



// WEBPACK FOOTER //
// ./components/Search/index.jsx